import { type Theme, type LightVariant, type DarkVariant } from "@/contexts/AppContext";
import { useAppContext } from "@/hooks/useAppContext";
import { useSystemTheme } from "./useSystemTheme";

/**
 * Hook to get and set the active theme
 * @returns Theme context with theme and setTheme
 */
export function useTheme(): {
  theme: Theme;
  lightVariant: LightVariant;
  darkVariant: DarkVariant;
  systemTheme: "light" | "dark";
  displayTheme: "light" | "dark";
  setTheme: (theme: Theme) => void;
  setLightVariant: (variant: LightVariant) => void;
  setDarkVariant: (variant: DarkVariant) => void;
} {
  const { config, updateConfig } = useAppContext();

  const systemTheme = useSystemTheme();
  const displayTheme = config.theme === 'system' ? systemTheme : config.theme;

  return {
    theme: config.theme,
    lightVariant: config.lightVariant,
    darkVariant: config.darkVariant,
    systemTheme,
    displayTheme,
    setTheme: (theme: Theme) => {
      updateConfig((currentConfig) => ({
        ...currentConfig,
        theme,
      }));
    },
    setLightVariant: (lightVariant: LightVariant) => {
      updateConfig((currentConfig) => ({
        ...currentConfig,
        lightVariant,
      }));
    },
    setDarkVariant: (darkVariant: DarkVariant) => {
      updateConfig((currentConfig) => ({
        ...currentConfig,
        darkVariant,
      }));
    },
  };
}
